import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import Counter from './liveMenuCounter';
import Item from './liveMenuItemPopular';


@withRouter
@inject('lineStore', 'routingStore')
@observer
class LiveMenuPopular extends Component {
  constructor(props) {
    super(props);
  }

  selectItem = () => {
    if (this.props.lineStore.menu.popular.order.length > 0) {
      // this.props.lineStore.menu.selectItem('pop', 4);
      this.props.history.push(`/${this.props.lineStore.mode}/popular`);
    }
  }

  toggle = () => {
    this.props.lineStore.menu.toggleOpenItem(null, 4);
  }

  render() {
    const { popular, isOpen } = this.props.lineStore.menu;
    const isOpened = isOpen.popular;

    return (
      <div className="line-left-column-popular-cont">
        <div className='line-popular-cont'>
          <div className="favourites-sport-item">
            {Boolean(popular.count) && (
              <button
                className={`favourites-sport-item-toggle ${isOpened ? 'f-i-t-a' : ''}`}
                onClick={this.toggle}
              >
                <div>
                  <span className="f-s-ico-arrow_buttom_1" />
                </div>
              </button>
            )}
            <button
              className="favourites-item-load line-popular-load s-g-popular"
              onClick={this.selectItem}
            >
              <span className="line-sport-menu-item-ico f-s-ico-popular" />
              <Counter count={popular.count} />
              <div className="favourites-item-load-label">Популярное</div>
            </button>
            {isOpened && (
              <div className="line-popular-data">
                {popular.order.map(o => (
                  <Item
                    key={o}
                    id={o}
                    type={5}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default LiveMenuPopular;



// WEBPACK FOOTER //
// ./src/components/liveMenu/liveMenuPopular.jsx